/// Menu
import Metismenu from "metismenujs";
import React, { Component, useContext, useEffect, useState } from "react";
/// Scroll
import PerfectScrollbar from "react-perfect-scrollbar";
/// Link
import { Link } from "react-router-dom";
import { useScrollPosition } from "@n8tb1t/use-scroll-position";
import { ThemeContext } from "../../../context/ThemeContext";
import { useFeatures } from "../../../context/FeatureContext";
import CurrentUser from "./CurrentUser";
import { Badge } from "react-bootstrap";
import { use } from "react";

class MM extends Component {
  componentDidMount() {
    this.$el = this.el;
    this.mm = new Metismenu(this.$el);
  }
  componentWillUnmount() {
  }
  render() {
    return (
      <div className="mm-wrapper">
        <ul className="metismenu" ref={(el) => (this.el = el)}>
          {this.props.children}
        </ul>
      </div>
    );
  }
}

const SideBar = ({ companyId }) => {

  const { features } = useFeatures()
  const { iconHover, sidebarposition, headerposition, sidebarLayout } = useContext(ThemeContext);

  // Helper function to check features
  const hasFeature = (featureName) => {
    return features && features[featureName] === true;
  };

  // Helper to create disabled menu items (for items you want to show as "coming soon" or "premium")
  const DisabledMenuItem = ({ to, label, premiumFeature = true }) => (
    <li className="disabled-menu-item">
      <Link
        className="disabled-link"
        to={`/${companyId}/upgrade?feature=${premiumFeature}`}
        onClick={(e) => {
          e.preventDefault();
          // You could show a modal here explaining the feature is premium
          alert(`${label} kräver en premium prenumeration.`);
        }}
      >
        {label}
        <Badge className="ms-2" variant="warning" style={{ fontSize: '10px' }}>Premium</Badge>
      </Link>
    </li>
  );

  const ComingSoonMenuItem = ({ label }) => (
    <li className="menu-item-coming-soon">
      <Link className="disabled-link mm-active" to={`/${companyId}/upgrade?feature=coming-soon`} >
        {label}
        <Badge bg="secondary" className="ms-2" style={{ fontSize: '10px' }}>Kommer snart</Badge>
      </Link>
    </li >
  );

  // 3. New feature indicator (for enabled features that are new)
  const NewFeatureBadge = () => (
    <Badge bg="success" className="ms-2 pulse-badge" style={{ fontSize: '10px' }}>New</Badge>
  );

  // Initialize metismenu and event listeners (keep as is)
  useEffect(() => {
    var btn = document.querySelector(".nav-control");
    var aaa = document.querySelector("#main-wrapper");

    function toggleFunc() {
      return aaa && aaa.classList.toggle("menu-toggle");
    }

    if (btn) {
      btn.addEventListener("click", toggleFunc);
    }

    //sidebar icon Heart blast
    var handleheartBlast = document.querySelector('.heart');
    function heartBlast() {
      return handleheartBlast && handleheartBlast.classList.toggle("heart-blast");
    }

    if (handleheartBlast) {
      handleheartBlast.addEventListener('click', heartBlast);
    }

    return () => {
      if (btn) {
        btn.removeEventListener("click", toggleFunc);
      }
      if (handleheartBlast) {
        handleheartBlast.removeEventListener('click', heartBlast);
      }
    };
  }, []);
  const [scrollPosition, setScrollPosition] = useState(0);

  useScrollPosition(
    ({ currPos }) => {
      setScrollPosition(currPos.y);
    },
    [],
    null,
    false,
    3000 // Add throttling to reduce update frequency (300ms)
  );

  let path = window.location.pathname;
  path = path.split("/");
  path = path[path.length - 1];

  /// Active menu
  let dashBoard = [
    "dashboard",
    "home",
  ],
    reports = [
      "vatreport",
      "balansreport",
      "resultatreport",
      "huvudbok",
    ],
    bookkeeping = [
      "verifications",
      "newverification",
      "ai-assistant",
    ],
    bank = [
      "bank",
      "bankstatements",
      "bank-accounts",
      "skattekonto",
    ],
    factoring = [
      "invoices",
      "create-invoices",
      "customers",
      "articles",
    ],
    purchaseandorders = [
      "supplier-invoices",
      "create-supplier-invoices",
      "suppliers",
    ],
    personell = [
      "employees",
      "payroll/periods",
      "schedule",
    ],
    settings = [
      "settings",
      "personal-settings",
    ],
    tools = [
      "moms",
      "timdebitering",
      "konto",
      "bokslut",
      "rapporter",
      "dokument",
    ];

  return (
    <div className={`dlabnav ${iconHover} ${(sidebarposition?.value === "fixed" &&
      sidebarLayout?.value === "horizontal" &&
      headerposition?.value === "static")
      ? scrollPosition > 120
        ? "fixed"
        : ""
      : ""
      }`}
    >
      <PerfectScrollbar className="dlabnav-scroll">
        <MM className="metismenu" id="menu">
          <li className={`${dashBoard.includes(path) ? "mm-active" : ""}`}>
            <Link className="has-arrow" to="#" >
              <i className="fas fa-home"></i>
              <span className="nav-text">Översikt</span>
            </Link>
            <ul >
              <li><Link className={`${path === "dashboard" ? "mm-active" : ""}`} to={`/${companyId}/dashboard`}> Översikt</Link></li>
            </ul>
          </li>

          <li className={`${reports.includes(path) ? "mm-active" : ""}`}>
            <Link className="has-arrow" to="#" >
              <i className="fas fa-chart-bar"></i>
              <span className="nav-text">Raporter</span>
            </Link>
            <ul >
              <li><Link className={`${path === "vatreport" ? "mm-active" : ""}`} to={`/${companyId}/vat-periods`}>Momsraport</Link></li>
              <li><Link className={`${path === "balansreport" ? "mm-active" : ""}`} to={`/${companyId}/reports/balance`}>Balansrapport</Link></li>
              <li><Link className={`${path === "balansreport" ? "mm-active" : ""}`} to={`/${companyId}/reports/result`}>Resultatrapport</Link></li>
              <li><Link className={`${path === "huvudbok" ? "mm-active" : ""}`} to={`/${companyId}/reports/mainledger`}>Huvudbok</Link></li>
              <ComingSoonMenuItem label="Bokslut" />
            </ul>
          </li>

          {hasFeature("banking_integration") &&
            <li className={`${bank.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow" to="#" >
                <i className="fas fa-university"></i>
                <span className="nav-text">Bank & Skatt</span>
              </Link>
              <ul >
                <li><Link className={`${path === "bankstatements" ? "mm-active" : ""}`} to={`/${companyId}/bankstatements`}>Banktransaktioner</Link></li>
                <li><Link className={`${path === "skattekonto" ? "mm-active" : ""}`} to={`/${companyId}/skattekonto`}>Skattekonto</Link></li>
                <li><Link className={`${path === "bank-accounts" ? "mm-active" : ""}`} to={`/${companyId}/bank-accounts`}>Konton</Link></li>
              </ul>
            </li>
          }

          {hasFeature("bookkeeping") &&
            < li className={`${bookkeeping.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow" to="#" >
                <i className="fas fa-book"></i>
                <span className="nav-text">Bokföring</span>
              </Link>
              <ul >
                <li><Link className={`${path === "verifications" ? "mm-active" : ""}`} to={`/${companyId}/verifications`}>Bokfört</Link></li>
                {/*<li><Link className={`${path === "verifications" ? "mm-active" : ""}`} to={`/${companyId}/newverification`}>Nytt</Link></li>
                <li><Link className={`${path === "verifications" ? "mm-active" : ""}`} to={`/${companyId}/create-bookkeeping-entry`}>Nytt</Link></li>*/}

                {hasFeature("ai_assistant") && (
                  <li>
                    <Link
                      className={`${path === "ai-assistant" ? "mm-active" : ""}`}
                      to={`/${companyId}/ai-assistant`}
                      style={{
                        color: path === "ai-assistant" ? 'inherit' : '#3b82f6',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                      }}
                    >

                      AI Assistant
                      <Badge bg="primary" className="ms-auto" style={{ fontSize: '10px' }}>
                        Beta
                      </Badge>
                    </Link>
                  </li>
                )}

              </ul>
            </li>}

          {hasFeature("invoicing") &&
            <li className={`${factoring.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow" to="#" >
                <i className="fas fa-money-bill"></i>
                <span className="nav-text">Fakturering och offerter</span>
              </Link>
              <ul >
                <li><Link className={`${path === "invoices" ? "mm-active" : ""}`} to={`/${companyId}/invoices`}>Kundfakturor</Link></li>
                <li><Link className={`${path === "invoices" ? "mm-active" : ""}`} to={`/${companyId}/quotes`}>Offerter</Link></li>
                <li><Link className={`${path === "customers" ? "mm-active" : ""}`} to={`/${companyId}/customers`}>Kunder</Link></li>
                <li><Link className={`${path === "articles" ? "mm-active" : ""}`} to={`/${companyId}/articles`}>Artiklar</Link></li>
              </ul>
            </li>
          }

          {hasFeature("expense_management") &&
            <li className={`${purchaseandorders.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow" to="#" >
                <i className="fas fa-shopping-cart"></i>
                <span className="nav-text">Leverantörer och inköp</span>
              </Link>
              <ul >
                <li><Link className={`${path === "supplier-invoices" ? "mm-active" : ""}`} to={`/${companyId}/supplier-invoices`}>Leverantörsfakturor</Link></li>
                {/*<li><Link className={`${path === "create-supplier-invoices" ? "mm-active" : ""}`} to={`/${companyId}/create-supplier-invoices`}>Skapa ny leverantörsfaktura</Link></li>*/}
                <li><Link className={`${path === "suppliers" ? "mm-active" : ""}`} to={`/${companyId}/suppliers`}>Leverantörer</Link></li>
              </ul>
            </li>
          }

          {hasFeature("personell_management") &&
            <li className={`${personell.includes(path) ? "mm-active" : ""}`}>
              <Link className="has-arrow" to="#" >
                <i className="fas fa-person-booth"></i>
                <span className="nav-text">Personal</span>
              </Link>
              <ul >
                <li><Link className={`${path === "employees" ? "mm-active" : ""}`} to={`/${companyId}/employees`}>Anställda</Link></li>
                <li><Link className={`${path === "periods" ? "mm-active" : ""}`} to={`/${companyId}/payroll/periods`}>Löner</Link></li>
                {/*<li><Link className={`${path === "schedule" ? "mm-active" : ""}`} to={`/${companyId}/schedule`}>Schema</Link></li>*/}
              </ul>
            </li>
          }

          {/*
          <li className={`${tools.includes(path) ? "mm-active" : ""}`}>
            <Link className="has-arrow" to="#" >
              <i className="fas fa-tools"></i>
              <span className="nav-text">Verktyg</span>
            </Link>
            <ul >
              <li><Link className={`${path === "employees" ? "mm-active" : ""}`} to={`/${companyId}/salarycalculator`}>Räkna ut lön</Link></li>
            </ul>
          </li>
          */}

          <li className='test-settings'>
            <Link className="has-arrow" to="#" >
              <i className="fas fa-cogs"></i>
              <span className="nav-text">Inställningar</span>
            </Link>
            <ul >
              <li><Link className={`${path === "settings" ? "mm-active" : ""}`} to={`/${companyId}/settings`}>Företaget</Link></li>
              {/*<li><Link className={`${path === "personal-settings" ? "mm-active" : ""}`} to={`/${companyId}/personal-settings`}>Personliga</Link></li>*/}
            </ul>
          </li>
        </MM>
        <div className="copyright">
          <p><strong>Riza Consulting AB</strong> © 2025 All Rights Reserved</p>
          <p className="fs-12">Made with <span className="heart"></span> by Riza Consulting AB</p>
        </div>
      </PerfectScrollbar>
    </div>
  );
};

export default SideBar;
